export default "__VITE_ASSET__CyBBiY4D__"